import { Controller } from "@hotwired/stimulus"

// Replaces Bootstrap dropdown functionality with pure Stimulus
export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    // Add click outside event listener when controller connects
    this.clickOutsideHandler = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.clickOutsideHandler)

    // Make sure the menu is hidden initially
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("tw-hidden")
    }
  }

  disconnect() {
    // Clean up event listener when controller disconnects
    document.removeEventListener("click", this.clickOutsideHandler)
  }

  handleOutsideClick(event) {
    // Only process if we have a menu target
    if (this.hasMenuTarget) {
      // Check if the click is outside the controller element
      if (!this.element.contains(event.target)) {
        this.hide()
      }
    }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    // Close all other dropdowns first
    this.closeAllOtherDropdowns()

    if (this.isOpen()) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.menuTarget.classList.remove("tw-hidden")

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("tw-hidden")

      if (this.hasButtonTarget) {
        this.buttonTarget.setAttribute("aria-expanded", "false")
      }
    }
  }

  closeAllOtherDropdowns() {
    // Find all other dropdowns and close them
    const allDropdowns = document.querySelectorAll("[data-controller='dropdown']")

    allDropdowns.forEach(dropdown => {
      if (dropdown !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(dropdown, "dropdown")
        if (controller && controller.isOpen()) {
          controller.hide()
        }
      }
    })
  }

  isOpen() {
    return !this.menuTarget.classList.contains("tw-hidden")
  }
}